import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}><path d="M7 13.667A6.667 6.667 0 117 .333a6.667 6.667 0 010 13.334zM6.333 9v1.333h1.334V9H6.333zm1.334-1.097A2.334 2.334 0 007 3.333c-1.112 0-2.07.785-2.289 1.876l1.308.262A1.001 1.001 0 117 6.667a.667.667 0 00-.667.666v1h1.334v-.43z" /></svg>);